<template>
  <div class="bg-white dark:bg-[#0a0e19] py-[60px] md:py-[80px] lg:py-[135px]">
    <div
      class="mx-auto px-[12.5px] md:max-w-[720px] lg:max-w-[960px] xl:max-w-[1255px]"
    >
      <div class="grid grid-cols-1 lg:grid-cols-2 gap-[25px] items-center">
        <div
          class="xl:-mr-[25px] 2xl:-mr-[45px] rounded-[25px] order-2 lg:order-1"
        >
          <img
            src="@/assets/images/forgot-password.jpg"
            alt="forgot-password-image"
            class="rounded-[25px]"
          />
        </div>
        <div
          class="xl:pl-[90px] 2xl:pl-[120px] order-1 lg:order-2"
        >
          <img
            src="@/assets/images/logos/sidebarlogo.png"
            alt="logo"
            class="inline-block max-w-[160px]"
          />
          <div class="my-[17px] md:my-[25px]">
            <h1
              class="font-semibold text-[22px] md:text-xl lg:text-2xl mb-[5px] md:mb-[12px]"
            >
              Forgot your password?
            </h1>
            <p
              class="font-medium leading-[1.5] lg:text-md text-[#445164] dark:text-gray-400"
            >
              Enter the email address you used when you joined and we'll send
              you instructions to reset your password.
            </p>
          </div>
          
          <div v-if="successMessage" class="mb-4 p-3 bg-green-100 text-green-700 rounded-md">
            {{ successMessage }}
          </div>
          <div v-if="errorMessage" class="mb-4 p-3 bg-red-100 text-red-700 rounded-md">
            {{ errorMessage }}
          </div>
          
          <form @submit.prevent="handleResetPassword">
            <div class="mb-[15px] relative">
              <label
                class="mb-[10px] md:mb-[12px] text-black dark:text-white font-medium block"
              >
                Email Address
              </label>
              <input
                v-model="email"
                type="email"
                class="h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500"
                placeholder="example@clickai.live"
                required
              />
            </div>
            <button
              type="submit"
              :disabled="isLoading"
              class="md:text-md block w-full text-center transition-all rounded-md font-medium mt-[20px] md:mt-[25px] py-[12px] px-[25px] text-white bg-primary-500 hover:bg-primary-400 disabled:opacity-70 disabled:cursor-not-allowed"
            >
              <span class="flex items-center justify-center gap-[5px]">
                <i v-if="!isLoading" class="material-symbols-outlined"> autorenew </i>
                <span v-if="isLoading" class="inline-block w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
                {{ isLoading ? 'Sending...' : 'Reset Password' }}
              </span>
            </button>
          </form>
          <p class="mt-[15px] md:mt-[20px]">
            Back to
            <RouterLink
              to="/authentication/sign-in"
              class="text-primary-500 transition-all font-semibold hover:underline"
            >
              Sign In
            </RouterLink>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import { RouterLink } from "vue-router";
import { authService } from "@/utils/supabase";

export default defineComponent({
  name: "ForgotPassword",
  components: {
    RouterLink
  },
  setup() {
    const email = ref("");
    const isLoading = ref(false);
    const errorMessage = ref("");
    const successMessage = ref("");

    const handleResetPassword = async () => {
      try {
        isLoading.value = true;
        errorMessage.value = "";
        successMessage.value = "";

        const { error } = await authService.resetPassword(email.value);
        
        if (error) {
          errorMessage.value = error.message || "אירעה שגיאה בשליחת הוראות איפוס סיסמה";
          return;
        }
        
        successMessage.value = "הוראות לאיפוס סיסמה נשלחו לאימייל שהזנת";
      } catch (error: any) {
        console.error("Error during password reset:", error);
        errorMessage.value = error?.message || "אירעה שגיאה בלתי צפויה";
      } finally {
        isLoading.value = false;
      }
    };

    return {
      email,
      isLoading,
      errorMessage,
      successMessage,
      handleResetPassword
    };
  }
});
</script>
